import {Vue} from 'vue-property-decorator';
import {CurrencyFilter} from '../filters/currency';
import {DayjsFilter} from '../filters/dayjs';
import {PhoneNumberFilter} from '../filters/phone-number';
import {RelativeDayOfWeekFilter} from '@customer-portal/shared';
import {TitleFilter} from '../filters/title';

Vue.filter('currency', CurrencyFilter);
Vue.filter('dayjs', DayjsFilter);
Vue.filter('phoneNumber', PhoneNumberFilter);
Vue.filter('relativeDayOfWeek', RelativeDayOfWeekFilter);
Vue.filter('title', TitleFilter);
